export default __webpack_public_path__ + "maksim.38fd8540.png";